// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zUXV","footer":"styles_footer__1BPdB"};